<template>
    <div id="rules_page" class="page_body">
        <h1>Rules</h1>

        <div id="info">
            <div id="general">
                <div class="left_col">
                    <h2>General</h2>

                    <p>
                        The number of Individual Sales Opportunities (ISOs) and value in your sales pipeline are only as genuine as the quality of each ISO and Sales Stage, 
                        that you as the sales person, have chosen to allocate it to. An ISO should only be allocated to a Sales Stage if it genuinely meets the Rules of Allocation stated. 
                        If your ISO does not meet the rules sated, you should down grade it until you have made adequate progress to meet those rules. The value allocated to your ISO should 
                        be based upon the company standard of £5,000 unless you have new and better information to qualify the annual value to have allocated. Be prepared to explain how you 
                        have arrived at your value or prepare for it to be down-graded. The Value Weighting for Pipeline is based upon the Sales Stage allocated by you as the sales person. 
                        The weighting cannot be adjusted unless you reallocate the Sales Stage of the ISO. Good luck out there...
                    </p>
                </div>

                <div class="right_col">

                </div>
            </div>

            <div id="column_info">
                <h2>Column Value Allocation</h2>

                <div class="card">
                    <div class="head">
                        <h3>Opportunity</h3>
                        <span>{{ getColumnPercentages[0] }}</span>
                    </div>

                    <div class="body">
                        <p>The organisation concerned is a legitimate business that trades in our market and buys the types of services we offer. We have identified a suitable individual and will be making contact within the next 7 days.</p>
                    </div>
                </div>
                <div class="card">
                    <div class="head">
                        <h3>Prospect</h3>
                        <span>{{ getColumnPercentages[1] }}</span>
                    </div>

                    <div class="body">
                        <p>We have spoken to the organisation and have scheduled a new business meeting, within the next four weeks, with a senior buyer of the services we offer. They are interested in our proposition.</p>
                    </div>
                </div>
                <div class="card">
                    <div class="head">
                        <h3>Proposal</h3>
                        <span>{{ getColumnPercentages[2] }}</span>
                    </div>

                    <div class="body">
                        <p>	We have met with a senior buyer of the type of services we offer, and they are interested in receiving a formal priced proposal which will form the basis of a further meeting with the decision maker. We have a date agreed for the next meeting.</p>
                    </div>
                </div>
                <div class="card">
                    <div class="head">
                        <h3>Presentation</h3>
                        <span><span>{{ getColumnPercentages[3] }}</span></span>
                    </div>

                    <div class="body">
                        <p>We are at pre-contract stage and would bet our next salary cheque that we will win the work within four weeks.</p>
                    </div>
                </div>
                <div class="card">
                    <div class="head">
                        <h3>Won</h3>
                        <span><span>{{ getColumnPercentages[4] }}</span></span>
                    </div>

                    <div class="body">
                        <p>We have signed the contract to receive work within the next four weeks or, we have already begun to receive work and the contract will be signed this month.</p>
                    </div>
                </div>
                <div class="card">
                    <div class="head">
                        <h3>Lost</h3>
                        <span>{{ getColumnPercentages[5] }}</span>
                    </div>

                    <div class="body">
                        <p>There was a genuine opportunity and we have been unsuccessful this time.</p>
                    </div>
                </div>
                <div class="card">
                    <div class="head">
                        <h3>No Opportunity</h3>
                        <span>{{ getColumnPercentages[6] }}</span>
                    </div>

                    <div class="body">
                        <p>	Upon further discussion, there was no genuine opportunity to chase.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'Rules',
        computed: {
            ...mapGetters(['getColumnPercentages'])
        },
        mounted() {
            this.$store.dispatch('getAllBoardPostData');
        }
    }
</script>

<style lang="scss" scoped>
    #rules_page{
        background-color: #eaeaea;;
        padding: 5rem;

        h1{
            font-size: 3rem;
            font-weight: 700;
            line-height: 1.3;
            color: $primary-three;
            margin-bottom: 4rem;
        }

        #info{
            padding: 5rem;
            background-color: #fff;

            #general{
                display: flex;
                margin-bottom: 4rem;

                h2{
                    font-size: 3rem;
                    font-weight: 700;
                    line-height: 1.3;
                    margin-bottom: 4rem;
                }

                .left_col{
                    width: 50%;

                    p{
                        font-size: 1.8rem;
                        font-weight: 300;
                        line-height: 1.3;
                    }
                }

                .right_col{
                    width: 50%;
                }
            }

            #column_info{
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;

                h2{
                    font-size: 3rem;
                    font-weight: 700;
                    line-height: 1.3;
                    margin-bottom: 4rem;
                    width: 100%;
                }

                .card{
                    background-color: #fff;
                    width: 30%;
                    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.4);
                    padding: 2rem;
                    margin-bottom: 2rem;

                    .head{
                        display: flex;
                        justify-content: space-between;
                        margin-bottom: 2rem;

                        h3{
                            font-size: 2rem;
                            font-weight: 600;
                            line-height: 1.3;
                        }

                        span{
                            font-size: 2rem;
                            font-weight: 300;
                            line-height: 1.3;
                        }
                    }

                    .body{
                        p{
                            font-size: 1.8rem;
                            font-weight: 300;
                            line-height: 1.3;
                        }
                    }
                }
            }
        }
    }
</style>